// MARK:- OS 2.0 web component that toggles the .has-banner class on <body>
// when the announcement-bar section enters / leaves the DOM.
//
// File naming: standalone web components in this theme use the `component-`
// prefix in the FILE NAME (`assets/component-tabs.js`, `assets/component-banner.js`, …)
// so they sort together in the assets directory. The custom element name, class,
// and data attributes stay short — `<as-banner>`, AsBanner.
//
// Architecture: hand-edited asset, NOT a webpack/gulp build output. Loaded once
// per page from sections/announcement-bar.liquid via:
//
//   <script src="{{ 'component-banner.js' | asset_url }}" type="module"></script>
//
// Why a component instead of a theme setting: body-class state follows section
// presence (Shopify mounts/unmounts the element when merchants edit, hide, or
// remove the section in the customizer). Driving the class from the section's
// own DOM keeps merchant control on the section itself — no theme-settings hunt
// for an unrelated toggle. connectedCallback / disconnectedCallback handle every
// lifecycle case (initial render, settings reload, eye-icon hide, delete, re-add).

class AsBanner extends HTMLElement {
  connectedCallback() {
    document.body.classList.add('has-banner');
  }

  disconnectedCallback() {
    document.body.classList.remove('has-banner');
  }
}

if (!customElements.get('as-banner')) {
  customElements.define('as-banner', AsBanner);
}
